<template>
  <view @click="toClick" :class="'yq-icon yq-iconfont hj-icon-'+name" :style="{transform: 'rotateZ(' + rotateZ + ')'}"/>
</template>

<script>
export default {
  emits: ["click"],
  props: {
    name: {default: ""},
    rotateZ: {default: "0deg"},

  },
  components: {
  },
  data() {
    return {
    }
  },
  onLoad() {

  },
  methods: {
    toClick(event) {
      this.$emit("click", event);
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/font/iconfont.css";
.yq-iconfont{
  display: inline-flex;
}
</style>
